export const REGULAR_FONT = 'Varela, sans-serif';
export const HEADERS_FONT = 'Titillium Web, sans-serif';
